import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import BookDemoModal from "./BookDemoModal";
import "./Navbar.css";

function Navbar() {
  const location = useLocation();
  const [isBookDemoOpen, setIsBookDemoOpen] = useState(false);

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll("section.section"));
    const merchantSection = document.getElementById("merchant");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Handle intersection logic if needed
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((s) => observer.observe(s));
    if (merchantSection) {
      observer.observe(merchantSection);
    }
    return () => observer.disconnect();
  }, [location]);

  return (
    <nav className="navbar">
      <ul className="nav-links">
        <li>
          <Link
            to="/"
            className={location.pathname === "/" ? "active" : ""}
          >
            Home
          </Link>
        </li>
        <li>
          <Link
            to="/about"
            className={location.pathname === "/about" ? "active" : ""}
          >
            About
          </Link>
        </li>
        <li>
          <Link
            to="/contact"
            className={location.pathname === "/contact" ? "active" : ""}
          >
            Contact
          </Link>
        </li>
        <li>
          <button
            type="button"
            className="nav-link-button"
            onClick={() => setIsBookDemoOpen(true)}
          >
            Book a Demo
          </button>
        </li>
      </ul>
      <BookDemoModal isOpen={isBookDemoOpen} onClose={() => setIsBookDemoOpen(false)} />
    </nav>
  );
}

export default Navbar;
